import React from 'react';
import AnimatedSection from '../../components/blocks/AnimatedSection';
import CommitteeMemberCard from '../../components/blocks/CommitteeMemberCard';
import TransdisciplinarityIntro from '../../components/blocks/TransdisciplinarityIntro';
import { getEventImagePath } from '../../config/eventPaths';
import { getCommitteeMembersWithRoles, TITAN_EXECUTIVE_COMMITTEE } from '../../config/committees';

const Titan = () => {
    return (
        <div className="min-h-screen bg-gray-50 py-8">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                {/* Header */}
                <div className="text-center mb-16">
                    <div className="flex justify-center mb-1.5">
                        <img src="/asset/icons/TITAN_Logo_Original.svg" alt="TITAN Logo" className="h-60 w-auto" />
                    </div>
                    {/* <h1 className="text-4xl font-bold text-gray-900 mb-4">TITAN</h1> */}
                    <p className="text-xl text-gray-600 max-w-5xl mx-auto text-center mb-6">
                        Transdisciplinary Initiative for Talents and Innovators - HKU CC Student Learning Partner
                    </p>
                    <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                        <a
                            href="mailto:titanprojectshk@gmail.com"
                            className="inline-block px-6 py-3 rounded-full border border-gray-300 text-gray-700 font-semibold hover:border-orange-400 hover:text-orange-600 transition"
                        >
                            Email Us
                        </a>
                        <a
                            href="https://instagram.com/titanprojectshk"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-block px-6 py-3 rounded-full border border-gray-300 text-gray-700 font-semibold hover:border-purple-400 hover:text-purple-600 transition"
                        >
                            Follow on Instagram
                        </a>
                        <a
                            href="https://www.linkedin.com/company/transdisciplinary-initiative-for-talents-and-innovators/posts/?feedView=all"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-block px-6 py-3 rounded-full border border-gray-300 text-gray-700 font-semibold hover:border-blue-600 hover:text-blue-600 transition"
                        >
                            Follow on LinkedIn
                        </a>
                    </div>
                </div>

                {/* What is TITAN Section */}
                <AnimatedSection
                    className="mb-16"
                    heading={<h2 className="text-3xl font-semibold text-gray-900 mb-8">What is TITAN?</h2>}
                >
                    <div className="bg-white rounded-lg shadow-md p-8">
                        <div className="grid md:grid-cols-3 gap-8">
                            <div className="md:col-span-2">
                                <div className="grid md:grid-cols-1 gap-8 mb-4">
                                    <div>
                                        <h3 className="text-xl font-semibold text-gray-900 mb-4">Our Vision</h3>
                                        <p className="text-lg text-gray-700 leading-relaxed text-justify">
                                            The Transdisciplinary Initiative for Talents and Innovators (TITAN) is a student-centric initiative aimed towards promoting and cultivating transdisciplinary mindsets, skills, and works across broad areas of investigation, including but not limited to academia. TITAN is active in hosting conferences, publishing journals, organising research field trips, and beyond.
                                        </p>
                                    </div>
                                </div>
                                <div className="grid md:grid-cols-1 gap-8 mb-6">
                                    <div>
                                        <h3 className="text-xl font-semibold text-gray-900 mb-4">Our Partnerships</h3>
                                        <p className="text-lg text-gray-700 leading-relaxed text-justify">
                                            <a href="https://commoncore.hku.hk/team/transdisciplinary-initiative-for-talents-and-innovators-titan/" target="_blank" rel="noopener noreferrer">The initiative is a student partner of the Common Core Office</a>, the University of Hong Kong, under Common Core Hong Kong Learning Partners. It is endorsed by the Millennium Fellowship 2025 Cohort HKU Campus, which is presented by the United Nations Academic Impact (UNAI) and the Millennium Campus Network (MCN).
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="md:col-span-1">
                                <div className="sticky top-6">
                                    <img
                                        src="/asset/images/posters/TITAN.jpeg"
                                        alt="TITAN Poster"
                                        className="w-full rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200"
                                    />
                                </div>
                            </div>
                        </div>
                        {/* <div className="grid md:grid-cols-1 gap-8 mb-6">
                            <div>
                                <h3 className="text-xl font-semibold text-gray-900 mb-4">Vision</h3>
                                <p className="text-lg text-gray-700 leading-relaxed">
                                    To be a leading initiative in promoting and cultivating transdisciplinary mindsets, skills, and works across broad areas of investigation, including but not limited to academia.
                                </p>
                            </div>
                        </div>
                        <div>
                            <h3 className="text-xl font-semibold text-gray-900 mb-4">Aims</h3>
                            <ol className="list-decimal list-inside space-y-2 text-gray-700">
                                <li>Provide opportunities for students to experience transdisciplinarity and thus cultivate such mindsets and skills</li>
                                <li>Provide resources and networking for events that promote transdisciplinarity</li>
                            </ol>
                        </div> */}
                    </div>
                </AnimatedSection>

                <TransdisciplinarityIntro />

                {/* Events */}
                <AnimatedSection
                    id="mongolia"
                    className="mb-16"
                    heading={<h2 className="text-3xl font-semibold text-gray-900 mb-8">Events</h2>}
                >
                    <div className="bg-white rounded-lg shadow-md p-8">
                        <div className="space-y-6">
                            <a
                                href="/titan/mongolian-critical-zone"
                                className="block border-l-4 border-blue-500 pl-6 rounded-lg group transition-all duration-200 hover:bg-blue-50 hover:border-blue-600 hover:shadow-md cursor-pointer"
                            >
                                <div className="flex items-start space-x-4">
                                    <div className="flex-1 pt-4 pb-6">
                                        <h3 className="text-xl font-semibold text-gray-900 mt-2 mb-2 group-hover:text-blue-700 transition-colors">Mongolia Critical Zone</h3>
                                        <p className="text-gray-600 mb-2">January 2026</p>
                                        <p className="text-gray-700 text-justify">
                                            Conduct in-situ transdisciplinary research in Ulaanbaatar, Mongolia. Engage with sustainable urban living practices in Ger areas with <b>GerHub</b>. Empower youth in marginalised communities with <b>Nuudelch Zuslan</b>.
                                        </p>
                                    </div>
                                    <div className="flex-shrink-0">
                                        <img
                                            src={getEventImagePath('titan', 'mongolian-critical-zone', 'Experiential Learning in the Winter Steppes.jpg')}
                                            alt="Mongolia Research Trip"
                                            className="w-auto h-auto md:h-48 object-contain rounded-lg shadow-sm group-hover:shadow-lg transition-shadow duration-200"
                                        />
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </AnimatedSection>

                {/* Our Organization */}
                <AnimatedSection
                    className="mb-16"
                    heading={<h2 className="text-3xl font-semibold text-gray-900 mb-8">Organization</h2>}
                >
                    <div className="bg-white rounded-lg shadow-md p-8">
                        <div className="grid md:grid-cols-1 gap-8">
                            <div>
                                <h3 className="text-xl font-semibold text-gray-900 mb-4">Leadership</h3>
                                <p className="text-gray-700 text-lg leading-relaxed text-justify">
                                    The Executive Committee is the governing body of TITAN, serving as the highest authority to direct and oversee all subcommittees.
                                </p>
                            </div>
                            <div>
                                <h3 className="text-xl font-semibold text-gray-900 mb-4">Subcommittees</h3>
                                <p className="text-gray-700 text-lg leading-relaxed text-justify">
                                    Under the TITAN initiative, there are two subcommittees responsible for organising conferences and publishing journals. They are
                                    <ol className="mt-2 list-disc list-inside space-y-2 text-gray-700">
                                        <li>The Conference for Research and Transdisciplinary Experiential Learning (CORTEX) Organising Committee, and</li>
                                        <li>The Journal of Experiential Learning and Transdisciplinary Research (JELTR) Editorial Board.</li>
                                    </ol>
                                </p>
                            </div>
                        </div>
                    </div>
                </AnimatedSection>

                {/* Executive Board */}
                <AnimatedSection
                    className="mb-16"
                    heading={<h2 className="text-3xl font-semibold text-gray-900 mb-8">Executive Board</h2>}
                >
                    <div className="bg-white rounded-lg shadow-md p-8">
                        <p className="text-lg text-gray-700 leading-relaxed mb-6 text-justify">
                            Our executive board consists of dedicated leaders who guide TITAN's strategic direction and ensure the quality of our transdisciplinary initiatives.
                        </p>
                        <div className="grid md:grid-cols-2 gap-6">
                            {getCommitteeMembersWithRoles(TITAN_EXECUTIVE_COMMITTEE).map((member) => (
                                <CommitteeMemberCard key={member.name} {...member} />
                            ))}
                        </div>
                    </div>
                </AnimatedSection>

                {/* Subdivisions */}
                <AnimatedSection
                    className="mb-16"
                    heading={<h2 className="text-3xl font-semibold text-gray-900 mb-8">Subdivisions</h2>}
                >
                    <div className="bg-white rounded-lg shadow-md p-8">
                        <p className="text-lg text-gray-700 leading-relaxed mb-6 text-justify">
                            TITAN oversees and coordinates two key subdivisions that work together to advance transdisciplinary education and research.
                        </p>
                        <div className="grid md:grid-cols-2 gap-8">
                            <div className="p-6 border rounded-lg hover:shadow-md transition-shadow">
                                <div className="flex items-center mb-4">
                                    <img src="/asset/icons/CORTEX_Logo_Radial.svg" alt="CORTEX Logo" className="h-12 w-12 mr-4" />
                                    <h4 className="text-xl font-semibold text-gray-900">CORTEX</h4>
                                </div>
                                <p className="text-gray-700 mb-4 text-justify">
                                    Conference for Research and Transdisciplinary Experiential Learning - A student-led platform for transdisciplinary research and experiential learning.
                                </p>
                                <a href="/cortex" className="inline-block px-6 py-3 rounded-full border border-gray-300 text-gray-700 font-semibold hover:border-blue-400 hover:text-blue-600 transition">Learn More →</a>
                            </div>
                            <div className="p-6 border rounded-lg hover:shadow-md transition-shadow">
                                <div className="flex items-center mb-4">
                                    <img src="/asset/icons/JELTR_Logo_Full_Coloured.svg" alt="JELTR Logo" className="h-12 w-12 mr-4" />
                                    <h4 className="text-xl font-semibold text-gray-900">JELTR</h4>
                                </div>
                                <p className="text-gray-700 mb-4 text-justify">
                                    Journal of Experiential Learning & Transdisciplinary Research - An academically-recognized journal for undergraduate transdisciplinary works.
                                </p>
                                <a href="/jeltr" className="inline-block px-6 py-3 rounded-full border border-gray-300 text-gray-700 font-semibold hover:border-purple-400 hover:text-purple-600 transition">Learn More →</a>
                            </div>
                        </div>
                    </div>
                </AnimatedSection>

                {/* Recognition
                <section className="mb-16">
                    <h2 className="text-3xl font-semibold text-gray-900 mb-8">Recognition</h2>
                    <div className="bg-white rounded-lg shadow-md p-8">
                        <div className="grid md:grid-cols-2 gap-8">
                            <div>
                                <h3 className="text-xl font-semibold text-gray-900 mb-4">Awards & Certifications</h3>
                                <ul className="space-y-2 text-gray-700">
                                    <li>• Excellence in Educational Technology Award 2023</li>
                                    <li>• Best Student Support Platform 2022</li>
                                    <li>• Innovation in Career Guidance 2021</li>
                                </ul>
                            </div>
                            <div>
                                <h3 className="text-xl font-semibold text-gray-900 mb-4">Media Coverage</h3>
                                <ul className="space-y-2 text-gray-700">
                                    <li>• Featured in Education Today Magazine</li>
                                    <li>• Interview on Career Development Podcast</li>
                                    <li>• Case Study in Educational Innovation Journal</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section> */}

                {/* Reports
                <section className="mb-16">
                    <h2 className="text-3xl font-semibold text-gray-900 mb-8">Reports</h2>
                    <div className="bg-white rounded-lg shadow-md p-8">
                        <div className="grid md:grid-cols-2 gap-6">
                            <div className="p-4 border rounded-lg">
                                <h4 className="font-semibold text-gray-900 mb-2">Annual Report 2023</h4>
                                <p className="text-gray-600 text-sm mb-2">Comprehensive overview of our achievements and impact</p>
                                <button className="text-blue-600 hover:text-blue-800 text-sm">Download PDF</button>
                            </div>
                            <div className="p-4 border rounded-lg">
                                <h4 className="font-semibold text-gray-900 mb-2">Impact Assessment</h4>
                                <p className="text-gray-600 text-sm mb-2">Measuring the effectiveness of our programs</p>
                                <button className="text-blue-600 hover:text-blue-800 text-sm">Download PDF</button>
                            </div>
                        </div>
                    </div>
                </section> */}

                {/* SDGs */}
                <AnimatedSection
                    className="mb-16"
                    heading={<h2 className="text-3xl font-semibold text-gray-900 mb-8">Sustainable Development Goals</h2>}
                >
                    <div className="bg-white rounded-lg shadow-md p-8">
                        <div className="mb-8 flex flex-col sm:flex-row items-start gap-6">
                            <a
                                href="https://sdgs.un.org/goals/goal4"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex-shrink-0"
                                aria-label="Sustainable Development Goal 4: Quality Education"
                            >
                                <img
                                    src="/asset/icons/Goal 4/E_WEB_04.png"
                                    alt="SDG Goal 4: Quality Education"
                                    className="w-24 h-24 sm:w-28 sm:h-28 object-contain rounded-lg"
                                />
                            </a>
                            <div className="min-w-0">
                                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Quality Education</h3>
                                <p className="text-gray-700 leading-relaxed text-justify">
                                    TITAN is committed to supporting the United Nations Sustainable Development Goal 4: Quality Education.
                                    We believe that every student deserves access to comprehensive, personalized career guidance that helps them
                                    make informed decisions about their educational and professional futures.
                                </p>
                            </div>
                        </div>
                        <div className="grid md:grid-cols-3 gap-6">
                            <a
                                href="https://sdgs.un.org/goals/goal4"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-center p-4 border rounded-lg hover:shadow-md hover:scale-105 transition-all duration-200 cursor-pointer block"
                            >
                                <div className="w-16 h-16 bg-blue-100 rounded-full mx-auto mb-4 flex items-center justify-center">
                                    <span className="text-2xl">📚</span>
                                </div>
                                <h4 className="font-semibold text-gray-900 mb-2">Inclusive Education</h4>
                                <p className="text-gray-600 text-sm">Ensuring equal access to quality guidance</p>
                            </a>
                            <a
                                href="https://sdgs.un.org/goals/goal4"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-center p-4 border rounded-lg hover:shadow-md hover:scale-105 transition-all duration-200 cursor-pointer block"
                            >
                                <div className="w-16 h-16 bg-green-100 rounded-full mx-auto mb-4 flex items-center justify-center">
                                    <span className="text-2xl">🌱</span>
                                </div>
                                <h4 className="font-semibold text-gray-900 mb-2">Lifelong Learning</h4>
                                <p className="text-gray-600 text-sm">Supporting continuous skill development</p>
                            </a>
                            <a
                                href="https://sdgs.un.org/goals/goal4"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-center p-4 border rounded-lg hover:shadow-md hover:scale-105 transition-all duration-200 cursor-pointer block"
                            >
                                <div className="w-16 h-16 bg-purple-100 rounded-full mx-auto mb-4 flex items-center justify-center">
                                    <span className="text-2xl">🎯</span>
                                </div>
                                <h4 className="font-semibold text-gray-900 mb-2">Skills for Success</h4>
                                <p className="text-gray-600 text-sm">Preparing students for future challenges</p>
                            </a>
                        </div>
                    </div>
                </AnimatedSection>
            </div>
        </div>
    );
};

export default Titan;
